<template>
<div class="mall-provider">
  <div class="content">
    <h2>优质服务商</h2>
    <div class="list">
      <div class="card" v-for="el in storeList" :key="el.id"  @click="toDetail(el.id)">
        <VImg class="logo" :attachment-id="el.isvImg"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import VImg from '@/components/VImg.vue'
import {getStorePageList} from '@/api/treasury.js'

export default {
  name: "mallProvider",
  components: {VImg},
  data(){
    return{
      storeList:[],
      dataInfo: {
        serviceType: "",
        companyScaleType: "",
        companyName: "",
        queryModel: "ISV_LIBRARY",
        isRecommend:true,
      },
      page: {
        current: 1,
        size: 15,
      },
    }
  },
  methods:{
    loadGetStorePageList() {
      this.loading = true;
      getStorePageList(this.page, this.dataInfo).then((res) => {
        this.storeList = res.records;
        this.page.total = res.total;
        this.loading = false;
      });
    },
    toDetail(id) {
      console.log(id,'di-------')
      this.$router.push({
        path: "/treasury/provider",
        query: { id },
      });
    },
  },
  mounted() {
    this.loadGetStorePageList()
  }
}
</script>


<style scoped lang="scss">
.mall-provider{
  background: #F7F8FA;
  .content{
    width: 1280px;
    margin: 0 auto;
    padding: 64px 0;
    >h2{
      font-weight: 600;
      font-size: 32px;
      color: rgba(0,0,0,0.85);
      line-height: 45px;
      margin-bottom: 64px;
      text-align: center;
    }
    >.list{
      display: flex;
      flex-wrap: wrap;
      >.card{
        width: 236px;
        height: 80px;
        padding: 8px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: #FFF;
        .logo{
          max-width: 100%;
          max-height: 100%;
        }
      }
      >:not(:nth-child(5n)){
        margin-right: 25px;
      }
      >:not(:nth-child(-n+5)){
        margin-top: 25px;
      }
    }

  }
}
</style>
